import { ref } from "vue";
import { defineStore } from "pinia";
import { apiClient } from "../config";
import { UserModel, TokenModel } from "../models/UserModel";
import { sleep } from "@/utilities/utility-function";
import { useRouter } from "vue-router";
// import { Exception } from "sass";

export const useUserAuthStore = defineStore("user_auth_store", () => {
    const userInfo = ref(null);
    const tokenInfo = ref(null);
    const router = useRouter();

    //save row data
    async function login(username, password) {
        try {
            const auth_data = {
                username: username,
                password: password
            }
            const response = await apiClient.post(`/users/login/`, auth_data)
            userInfo.value = new UserModel(response.data.user)
            tokenInfo.value = new TokenModel(response.data.tokens)

            //save the user and token data
            await saveUserToken();

            await sleep(2000);

        } catch (error) {
            console.log("Error while login to the account: ", error);
            // Axios wraps failed responses here
            if (error.response && error.response.status >= 400) {
                const errorMessage = error.response.data?.error || 'Login failed. Please try again.';
                throw new Error(errorMessage);
            } else {
                // Handle network or unknown errors
                throw new Error('Network error or server not responding.');
            }
        }
    }
    //logout
    async function logout() {
        try {
            const auth_data = {
                username: userInfo.value.username,
            }
            const response = await apiClient.post(`/users/logout/`, auth_data)
            // if response is clear the data from local storage
            if (response.status == 200) {
                localStorage.clear()
                userInfo.value = null;
                tokenInfo.value = null;
                router.push('/');
            }
        } catch (error) {
            console.log("Error while loging out to the account: ", error)
            throw error
        }
    }

    //refresh token
    async function refreshToken() {
        try {
            const token_data = {
                refresh: tokenInfo.value.refresh,
            }
            const response = await apiClient.post(`/api/token/refresh/`, token_data)
            // if response is 200
            if (response.status == 200) {
                tokenInfo.value = new TokenModel(response.data.tokens)
                localStorage.setItem("tokens", JSON.stringify(tokenInfo.value))
            }
        } catch (error) {
            console.log("Error while refreshing the token: ", error)
            throw error
        }
    }

    //save token to local
    async function saveUserToken() {
        try {
            localStorage.setItem("user", JSON.stringify(userInfo.value))
            localStorage.setItem("tokens", JSON.stringify(tokenInfo.value))
        } catch (error) {
            console.log("Error while sving the token to local storage: ", error)
            throw error
        }
    }

    async function getUserToken() {
        try {
            userInfo.value = JSON.parse(localStorage.getItem("user"))
            tokenInfo.value = JSON.parse(localStorage.getItem("tokens"))
        } catch (error) {
            console.log("Error while getting the token from local storage: ", error)
            throw error
        }
    }

    async function sendResetCode(email) {
        try {
            const resetEmail = {
                email: email,
            }
            const response = await apiClient.post(`/users/api/send-reset-code/`, resetEmail)
            // if response is 200
            if (response.status > 399) {
                throw new Error("Error while sending the code")
            }
        } catch (error) {
            console.log("Error while sending the reset code: ", error)
            // Axios wraps failed responses here
            if (error.response && error.response.status >= 400) {
                const errorMessage = error.response.data?.error || 'Error while sending the code';
                throw new Error(errorMessage);
            } else {
                // Handle network or unknown errors
                throw new Error('Network error or server not responding.');
            }
        }
    }

    async function resetPassword(code, newPassword, confirmPassword) {
        try {
            const resetPassword = {
                code: code,
                new_password: newPassword,
                confirm_password: confirmPassword,
            }
            const response = await apiClient.post(`/users/api/verify-reset-code/`, resetPassword)
            // if response is 200
            if (response.status > 399) {
                throw new Error("Error while reseting the password")
            }
        } catch (error) {
            console.log("Error while reseting the password: ", error)
            throw error
        }
    }


    return {
        userInfo,
        tokenInfo,
        login,
        logout,
        refreshToken,
        saveUserToken,
        getUserToken,
        sendResetCode,
        resetPassword
    }
})